module.exports = __webpack_public_path__ + "static/card-profile2-square-788e3d36e8c4d4120daeee6e57e7e85f.jpg";